export default "__VITE_ASSET__eb04da2f__"